function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2,.cls-5{fill:none;stroke-width:0.75px;}.cls-2,.cls-3,.cls-5{stroke:#adafb5;stroke-miterlimit:10;}.cls-3,.cls-4{fill:#adafb5;}.cls-3{stroke-width:0.74px;}.cls-5{stroke-linecap:round;}"));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, React.createElement("rect", {
  className: "cls-1",
  width: 60,
  height: 60
}), React.createElement("path", {
  className: "cls-2",
  d: "M16.46,25.79V38.1a.72.72,0,0,0,.72.72H20a.71.71,0,0,1,.72.71v.38a.72.72,0,0,0,.72.72H31a.72.72,0,0,0,.72-.72v-.38a.71.71,0,0,1,.72-.71h3.27a.72.72,0,0,0,.72-.72V25.79a.72.72,0,0,0-.72-.72H17.18A.72.72,0,0,0,16.46,25.79Z"
}), React.createElement("rect", {
  className: "cls-3",
  x: 22.41,
  y: 37.35,
  width: 7.61,
  height: 1.29,
  rx: 0.22
}), React.createElement("path", {
  className: "cls-4",
  d: "M34.62,35.55H21.1a.72.72,0,0,1-.72-.72l0-7.91a.71.71,0,0,1,.72-.71H34.66a.71.71,0,0,1,.71.72l0,7.91A.71.71,0,0,1,34.62,35.55Z"
}), React.createElement("line", {
  className: "cls-2",
  x1: 36.46,
  y1: 25.07,
  x2: 43.02,
  y2: 19.65
}), React.createElement("line", {
  className: "cls-5",
  x1: 38.74,
  y1: 26.45,
  x2: 41.02,
  y2: 24.56
}), React.createElement("line", {
  className: "cls-5",
  x1: 38.74,
  y1: 28.49,
  x2: 41.02,
  y2: 26.6
}), React.createElement("line", {
  className: "cls-5",
  x1: 38.74,
  y1: 31.73,
  x2: 41.02,
  y2: 29.85
}), React.createElement("line", {
  className: "cls-5",
  x1: 38.74,
  y1: 33.77,
  x2: 41.02,
  y2: 31.88
}), React.createElement("line", {
  className: "cls-5",
  x1: 21.05,
  y1: 23.6,
  x2: 23.74,
  y2: 21.19
}), React.createElement("line", {
  className: "cls-5",
  x1: 23.51,
  y1: 23.6,
  x2: 25.91,
  y2: 21.19
}), React.createElement("line", {
  className: "cls-5",
  x1: 27.15,
  y1: 23.6,
  x2: 29.56,
  y2: 21.19
}), React.createElement("line", {
  className: "cls-5",
  x1: 29.32,
  y1: 23.6,
  x2: 31.73,
  y2: 21.19
}), React.createElement("line", {
  className: "cls-5",
  x1: 32.4,
  y1: 23.6,
  x2: 35.38,
  y2: 21.19
}), React.createElement("line", {
  className: "cls-5",
  x1: 34.85,
  y1: 23.6,
  x2: 37.54,
  y2: 21.19
}), React.createElement("path", {
  className: "cls-5",
  d: "M16.66,25.3l6.4-5.73a.7.7,0,0,1,.44-.16H42.6a.7.7,0,0,1,.7.7V32.84a.69.69,0,0,1-.27.55l-6.82,5.25"
}), React.createElement("line", {
  className: "cls-2",
  x1: 16.46,
  y1: 38.82,
  x2: 21.97,
  y2: 33.95
})));

function SvgSfp(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 60 60"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "static/media/sfp.0bbbe931.svg";
export { SvgSfp as ReactComponent };